export const SET_STREAM_ORDER = "stream/SET_STREAM_ORDER";
export const SET_STREAM_POSITION = "stream/SET_STREAM_POSITION";
export const SET_STREAM_QTD = "stream/SET_STREAM_QTD";
